export enum ScaleModel {
  AXIS = 'AXIS',
  DINI_ARGEO = 'Dini Argeo',
  XK3118T1 = 'XK3118T1',
  RINSTRUM = 'Rinstrum',
  KPZ_52E91 = 'KPZ 52E-9-1',
}
export enum ConnectionType {
  ETHERNET = 'ETHERNET',
  RS232 = 'RS232',
}
export enum WEIGHING_UNITS {
  KG = 'KG',
  G = 'G',
}
export enum CommunicationMode {
  TRIGGERED_BY_US = 'TRIGGERED_BY_US',
  TRIGGERED_BY_SCALE = 'TRIGGERED_BY_SCALE',
}

export enum StableMeasurementMode {
  FIRST = 'FIRST',
  MEDIAN = 'MEDIAN',
  LAST = 'LAST',
}

export enum StableMeasurementSource {
  SCALE_BASED = 'SCALE_BASED',
  CALCULATED = 'CALCULATED',
}

export interface Scale {
  id: string;

  hostId: string;

  name: string;

  description?: string;

  model: ScaleModel;

  connectionType: ConnectionType;

  communicationMode: CommunicationMode;

  sendInterval?: number;

  weighingUnit: WEIGHING_UNITS;

  measurementAccuracy: number;

  ipAddress?: string;

  port?: number;

  portPath?: string;

  baudRate?: number;

  divisionId?: string;

  printerId?: string;

  measurementRegex?: string;

  groupIds?: string[];

  stableMeasurementEnabled: boolean;

  stableMeasurementSource: StableMeasurementSource;

  stableMeasurementMode: StableMeasurementMode;

  stableMeasurementTolerance?: number;

  stableMeasurementWindowMs?: number;

  stableMeasurementMinCount?: number;

  stableMeasurementZeroValue?: number;
}
